/**
 * Inicializa el botón de chat de WhatsApp según el código de país
 * @param {string} countryCode - Código de país (ej: 'br', 'es')
 * @param {string|number} countryID - ID de país (ej: '165', '56')
 */

import { timeToMinutes } from "./../helpers/functions";
import { loadGeo } from "./../services/geolocationService"; // Usar loadGeo del core, no del API
import {
  CHATCENTER_AVAILABLE_COUNTRIES_ID,
  PRE_SALES_AVAILABLE_COUNTRIES,
  CHAT_PHONES,
  CHAT_HOURS,
} from "./../config/chat";

const getGeoDataForChat = async () => {
  try {
    const geoData = await loadGeo(false, false, null); // No storage, no force, no country_code específico

    if (!geoData) {
      throw new Error("No se pudo obtener datos de geolocalización");
    }

    const now = new Date();
    return {
      countryCode: geoData.country?.toLowerCase(),
      countryID: geoData.country_id,
      todayDay: geoData.today_day || now.getDay(),
      todayHour: geoData.today_hour || now.toTimeString().slice(0, 5),
    };
  } catch (error) {
    console.warn("Error obteniendo datos de geo para chat:", error);
    const now = new Date();
    return {
      countryCode: "ar",
      countryID: "164",
      todayDay: now.getDay(),
      todayHour: now.toTimeString().slice(0, 5),
    };
  }
};

const isWorkingDay = (day) => {
  return day !== 0 && day !== 6;
};

const isWithinSalesHours = (timeInMinutes) => {
  const startMinutes = timeToMinutes(CHAT_HOURS.SALES_START);
  const endMinutes = timeToMinutes(CHAT_HOURS.SALES_END);
  return timeInMinutes >= startMinutes && timeInMinutes <= endMinutes;
};

export const getSalesNumber = (countryCode, countryID, todayDay, todayHour) => {

  const urlParams = new URLSearchParams(window.location.search);

  if (!countryCode || !countryID || !todayDay || !todayHour) {
    return CHAT_PHONES.chatcenter;
  }

  let day = todayDay;

  let timeString = urlParams.has("testTime")
    ? urlParams.get("testTime")
    : todayHour;

  let timeInMinutes = timeToMinutes(timeString);

  if (PRE_SALES_AVAILABLE_COUNTRIES.has(countryCode)) {
    if (isWorkingDay(day) && isWithinSalesHours(timeInMinutes)) {
      return CHAT_PHONES.sales;
    } else {
      return CHAT_PHONES.chatcenter;
    }
  } else if (countryCode === "br" || countryCode === "pt") {
    return CHAT_PHONES.brasil;
  } else if (CHATCENTER_AVAILABLE_COUNTRIES_ID.includes(Number(countryID))) {
    return CHAT_PHONES.chatcenter;
  }
  return CHAT_PHONES.chatcenter;
};

export const initializeChatBots = async (
  countryCode = null,
  countryID = null,
  todayDay = null,
  todayHour = null
) => {
  if (!countryCode || !countryID || todayDay === null || !todayHour) {

    const geoData = await getGeoDataForChat();

    countryCode = countryCode || geoData.countryCode;
    countryID = countryID || geoData.countryID;
    todayDay = todayDay !== null ? todayDay : geoData.todayDay;
    todayHour = todayHour || geoData.todayHour;
  }

  const urlParams = new URLSearchParams(window.location.search);

  let day;
  if (urlParams.has("testDay")) {
    day = parseInt(urlParams.get("testDay"));
  } else {
    day = todayDay;
  }

  let timeString;
  let timeInMinutes;
  if (urlParams.has("testTime")) {
    timeString = urlParams.get("testTime");
    timeInMinutes = timeToMinutes(timeString);
  } else {
    timeInMinutes = timeToMinutes(todayHour);
  }

  function getPhoneNumber() {
    return getSalesNumber(countryCode, countryID, day, todayHour);
  }

  function showWhatsApp(phoneNumber) {
    const existingButton = document.getElementById("a365-whatsapp-button");
    if (existingButton) {
      existingButton.remove();
    }

    const a = document.createElement("a");
    a.id = "a365-whatsapp-button";
    a.href = `https://wa.me/${phoneNumber}`;
    a.target = "_blank";

    a.setAttribute("data-phone", phoneNumber);
    a.setAttribute("data-timestamp", new Date().getTime());

    var image = new Image();
    image.src = "https://host2b.net/download/imagem/whatsapp-icon.png";
    image.setAttribute(
      "style",
      "height:52px; position:fixed; bottom:25px; right:25px; z-index:99999;"
    );
    image.setAttribute("data-selector", "img");
    a.appendChild(image);
    document.body.appendChild(a);
  }

  function showHubSpot() {
    let jsHS = document.createElement("script");
    jsHS.type = "text/javascript";
    jsHS.async = 1;
    jsHS.src = "//js.hs-scripts.com/3342240.js";
    document.body.appendChild(jsHS);
  }

  function showChatSupport(phoneNumber) {
    const messages = {
      es: {
        msg: "¿No encuentras lo que buscas? Chatea con nuestros asesores",
        wsapp:
          "Hola! necesito ayuda para elegir mi cobertura de viaje Assist 365",
      },
      pt: {
        msg: "Você não encontra o que procura? Converse com nossos consultores",
        wsapp: "Olá! Preciso de ajuda para escolher o  seguro da Assist 365.",
      },
    };

    const lang = localStorage.getItem("lang") || "es";
    const msg_width = lang === "es" ? "227" : "250";

    var image = new Image();
    image.src =
      "https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/wsapp_widget/wsapp_widget_logo.svg";

    const wc = document.createElement("a");
    wc.href = `https://wa.me/${phoneNumber}?text=${messages[lang]["wsapp"]}`;
    wc.target = "_blank";
    wc.setAttribute("id", "btn_whatsapp_productPage");

    const msg = document.createElement("div");
    msg.innerHTML = messages[lang]["msg"];

    const arrow = document.createElement("div");
    const styles = {
      arrow: ` width: 0; height: 0; border-top: 6px solid transparent; border-bottom: 6px solid transparent; border-left: 6px solid white; `,
      msg: ` padding: 0.5rem; background: white; text-align: center; border-radius: 8px; font-family: 'Inter', sans-serif; font-size: 14px; color: #1B2225; width: ${msg_width}px; line-height: 1.1; `,
      img: ` position: relative; top: 6px; `,
      container: ` position: fixed; bottom: 25px; right: 25px; z-index: 1000; display: flex; align-items: center; padding: 10px; border-radius: 8px; justify-content: flex-start; `,
    };

    msg.setAttribute("style", styles.msg);
    image.setAttribute("style", styles.img);
    arrow.setAttribute("style", styles.arrow);

    wc.setAttribute("style", styles.container);
    wc.appendChild(msg);
    wc.appendChild(arrow);
    wc.appendChild(image);
    document.body.appendChild(wc);
  }

  const path_name = window.location.pathname.split("/");
  if (path_name[2] === "products") {
    const phoneNumber = getPhoneNumber();
    setTimeout(() => {
      showChatSupport(phoneNumber);
    }, 20000);
  } else {
    if (PRE_SALES_AVAILABLE_COUNTRIES.has(countryCode)) {
      if (isWorkingDay(day)) {
        showHubSpot();
      }
      else {
        showWhatsApp(CHAT_PHONES.chatcenter);
      }
    }
    else if (CHATCENTER_AVAILABLE_COUNTRIES_ID.includes(Number(countryID))) {
      showWhatsApp(CHAT_PHONES.chatcenter);
    }
    else if (countryCode === "br" || countryCode === "pt") {
      showHubSpot();
    }
  }

  if (urlParams.has("testDay") || urlParams.has("testTime")) {
    const timeString = urlParams.get("testTime") || todayHour;
    console.info(
      `Modo de prueba: día=${day} (${isWorkingDay(day) ? "día laboral" : "fin de semana"
      }), hora=${timeString} (${timeInMinutes} minutos)`
    );
  }
};